import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  createhostellogin,
  getGCB,
  getHostelCategory,
  get_year_of_const,
  school_name_block_wise,
} from "../api/Users";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import axios from "../api/constant";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";

const HostelLogin = ({ role, userData }) => {
  const { t } = useTranslation();
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [Alldistricts, setAllDistricts] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);
  const [Allvillages, setAllVillages] = useState([]);
  const [AllGPs, setAllGPs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [markRequired, setMarkRequired] = useState(true);
  const [Hostelname, setHostelname] = useState("");
  const [Emailid, setEmailid] = useState("");
  const [SchoolName, setSchoolName] = useState("");
  const [Password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [Address, setAddress] = useState("");
  const [District, setDistrict] = useState("");
  const [Village, setVillage] = useState("");
  const [Role, setRole] = useState("");
  const [UDISE, setUDISE] = useState("");
  const [Block, setBlock] = useState("");
  const [GP, setGP] = useState("");
  const [number, setNumber] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phonenoError, setPhoneNoError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [passwordMismatchError, setPasswordMismatchError] = useState("");
  const [gcb, setGcb] = useState([]);
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [gbcType, setGcbType] = useState("");
  const [headmasterName, setHeadMasterName] = useState("");
  const [schoolType, setSchoolType] = useState("");
  const [hostelType, setHostelType] = useState("");
  const [yearOfConstruction, setYearOfConstruction] = useState("");
  const [allYearOfConstruction, setAllYearOfConstruction] = useState([]);
  const [schoolId, setSchoolId] = useState(null);

  const {
    register,
    reset,
    formState: { errors },
  } = useForm();
  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  useEffect(() => {
    get_year_of_const()
      .then((res) => {
        if (res.status === "success") {
          setAllYearOfConstruction(res.data.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
    getHostelCategory()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data.new_asset_query);
          setCategories(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
    getGCB()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setGcb(res.data.student_gbc_master);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
    axios
      .get("/get_all_districts")
      .then((response) => {
        console.log(response);
        if (response.data.status == "success") {
          setAllDistricts(response.data.data);
        } else {
          setAllDistricts([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  }, []);

  useEffect(() => {
    if (District) {
      axios
        .get(`/get_block_from_district?district_code=${District}`)
        .then((response) => {
          if (response.data.status == "success") {
            setAllBlocks(response.data.data.new_asset_query);
          } else {
            setAllBlocks([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching blocks:", error);
        });
    }
  }, [District]);

  useEffect(() => {
    if (District && Block) {
      axios
        .get(
          `/get_gp_from_block_and_district?district_code=${District}&block_code=${Block}`
        )
        .then((response) => {
          if (response.data.status == "success") {
            setAllGPs(response.data.data.new_asset_query);
          } else {
            setAllGPs([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching villages:", error);
        });
    }
  }, [District, Block]);

  useEffect(() => {
    if (District && Block && GP) {
      axios
        .get(
          `/get_village_from_gp_block_and_district?district_code=${District}&block_code=${Block}&gp_code=${GP}`
        )
        .then((response) => {
          if (response.data.status == "success") {
            setAllVillages(response.data.data.new_asset_query);
          } else {
            setAllVillages([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching villages:", error);
        });
    }
  }, [District, Block, GP]);

  useEffect(() => {
    const data = {
      block_code: userData.data.block_code,
    };
    if (role == 5) {
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  });

  const handleSchoolName = (e) => {
    try {
      const selectedSchoolId = e.target.value;
      setSchoolId(selectedSchoolId);
      // Fetch UDISE code based on selected school ID
      const selectedSchoolData = AllSchoolNames.find(
        (school) => school.school_id === selectedSchoolId
      );
      if (selectedSchoolData) {
        setUDISE(selectedSchoolData.UDISE_code);
      } else {
        setUDISE(""); // Reset UDISE code if school data not found
      }
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };
  

  const handleHostelType = (event) => {
    setHostelType(event.target.value);
  };

  const handleYearsOfConstruction = (event) => {
    setYearOfConstruction(event.target.value);
  };

  const handleDistrictChange = (event) => {
    setDistrict(event.target.value);
    setBlock("");
    setVillage("");
    setGP("");
    setAllBlocks([]);
    setAllVillages([]);
    setAllGPs([]);
    setAllSchoolNames([]);
    setSchoolName("");
    setHostelType("");
    setYearOfConstruction("");
  };

  // const handleBlockChange = (event) => {
  //   setBlock(event.target.value);
  //   setVillage("");
  //   setGP("");
  //   setAllVillages([]);
  //   setAllGPs([]);
  //   setAllSchoolNames([]);
  //   setSchoolName("");
  //   setHostelType("");
  //   setYearOfConstruction("");
  // };
  const handleBlockChange = (event) => {
    setBlock(event.target.value);
    setVillage("");
    setGP("");
    setAllVillages([]);
    setAllGPs([]);
    setAllSchoolNames([]);
    setSchoolName("");
    setHostelType("");
    setYearOfConstruction("");
    console.log(event.target.value);
    const data = {
      block_code: event.target.value,
    };
    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };
  const handleGPChange = (event) => {
    setGP(event.target.value);
    setVillage("");
    setAllVillages([]);
    setAllSchoolNames([]);
    setSchoolName("");
    setHostelType("");
    setYearOfConstruction("");
  };

  const handleVillageChange = (event) => {
    setVillage(event.target.value);
    setAllSchoolNames([]);
    setSchoolName("");
    setHostelType("");
    setYearOfConstruction("");
  };

  const validateEmail = (email) => {
    if (
      !(
        /^[a-zA-Z0-9._%+-]+@gmail.com$/.test(email) ||
        /^[a-zA-Z0-9._%+-]+@outlook.com$/.test(email) ||
        /^[a-zA-Z0-9._%+-]+@yahoo.com$/.test(email)
      )
    ) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const validatePhoneNo = (phoneno) => {
    if (!/^[0-9]{10}$/.test(phoneno)) {
      setPhoneNoError("Invalid PhoneNo format");
    } else {
      setPhoneNoError("");
    }
  };

  const validatePassword = (password) => {
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        password
      )
    ) {
      setPasswordError(
        "**Password must contain at least one lowercase letter, one uppercase letter, one digit, and one special character from the set @$!%*?&.."
      );
    } else {
      setPasswordError("");
    }
  };

  const handleSchoolType = (e) => {
    console.log(e.target.value);
    setSchoolType(e.target.value);
  };

  const handleNameChange = (e) => {
    setHeadMasterName(e.target.value);
  };

  const handleGCBChange = (e) => {
    setGcbType(e.target.value);
  };

  const handleSubmitForm = async (event, data) => {
    event.preventDefault();
    if (emailError) {
      toast.error("Please provide a valid email address.");
      return;
    }
    if (Password !== ConfirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const Postdata = {
      role_id: role,
      gm_id: GP,
      district_code: District,
      block_code: Block,
      gp_code: GP,
      village_code: Village,
      UDISE_code: UDISE,
      school_name: SchoolName,
      school_type: schoolType,
      category: category,
      gbc_id: gbcType,
    };

    createhostellogin(Postdata)
      .then((response) => {
        if (response.status == "success") {
          toast.success(response.message);
          reset();
          setDistrict("");
          setBlock("");
          setVillage("");
          setGP("");
          setSchoolType("");
          setCategory("");
          setSchoolName("");
          setGcbType("");
          setUDISE("");
          setHeadMasterName("");
          setAllBlocks([]);
          setAllVillages([]);
          setAllGPs([]);
          setNumber("");
          setAllSchoolNames([]);
          setConfirmPassword("");
          setEmailid("");
          setHostelType("");
          setYearOfConstruction("");
        }
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };

  const handleCategory = (e) => {
    setCategory(e.target.value.toUpperCase());
  };

  const handleUDISE = (e) => {
    setUDISE(e.target.value);
  };
  const toggleClearButton = () => {
    setDistrict("");
    setBlock("");
    setVillage("");
    setGP("");
    setSchoolType("");
    setCategory("");
    setSchoolName("");
    setGcbType("");
    setUDISE("");
    setHeadMasterName("");
    setAllBlocks([]);
    setAllVillages([]);
    setAllGPs([]);
    setNumber("");
    setAllSchoolNames([]);
    setPassword("");
    setConfirmPassword("");
    setEmailid("");
    setHostelType("");
    setYearOfConstruction("");
  };
  return (
    <>
      {/* <TopLoader loading={isLoading ? "50" : "100"} /> */}
      <div className="px-2 px-md-4">
        <h5 className="my-4">{t("Open New Hostel")}</h5>
        <form
          id="myform1"
          onSubmit={(e, data) => handleSubmitForm(e, data)}
          style={{ marginTop: "12px" }}
        >
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">
                {t("District")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="district"
                className="common-input form-select"
                onChange={handleDistrictChange}
                required
              >
                <option value="">{t("Select District")}</option>
                {/* Map assetOptions to generate option elements */}
                {Alldistricts &&
                  Alldistricts.map((row) => (
                    <option key={row.district_code} value={row.district_code}>
                      {" "}
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Block")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="GP"
                className="common-input form-select"
                onChange={handleBlockChange}
                required
              >
                <option value="">{t("Select Block")}</option>
                {Allblocks &&
                  Allblocks.map((row) => (
                    <option key={row.code} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* GP */}
            {/* <div className="col-md-4">
              <label className="form-label">
                {t("GP")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="GP" 
                className="common-input form-select"
                onChange={handleGPChange}
                required
              >
                <option value="">{t("Select GP")}</option>
                {AllGPs &&
                  AllGPs.map((row) => (
                    <option key={row.code} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div> */}
            <div
              className="col-md-4"
              // style={{ display: role == 4 ? "none" : "block" }}
            >
              <label className="form-label">{t("School Name")} </label>
              <select
                name="SchoolName" // value={AssetsType}
                className="common-input form-select"
                onChange={handleSchoolName}
                required
              >
                <option value="all">All</option>
                {AllSchoolNames &&
                  AllSchoolNames.map((row, index) => (
                    <option value={row.school_id}>{row.school_name}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="row" style={{ marginTop: "12px" }}>
            
              <div className="col-md-4"
              style={{display: schoolId!=null ? "block" : "none"}}>
                <label className="form-label">
                  {t("UDISE code")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  disabled
                  name="udise_code"
                  value={userData.data.UDISE_code}
                  className="form-control"
                  required
                />
              </div>
            
            {/* <div className="col-md-4">
              <label className="form-label">
                {t("School Type")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="schoolType"
                value={schoolType}
                className="common-input form-select"
                onChange={handleSchoolType}
                required
              >
                <option value="">{t("Select School Type")}</option>
                <option value="Residential">{t("Residential")}</option>
                <option value="Non Residential">{t("Non Residential")}</option>
              </select>
            </div> */}

            <div className="col-md-4 ">
              <label className="form-label">
                {t("Category")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="category"
                value={category}
                className="common-input form-select"
                onChange={handleCategory}
                required
              >
                <option value="">{t("Select Category Type")}</option>
                {categories.map((item) => (
                  <option value={item.category}>{t(item.category)}</option>
                ))}
              </select>
            </div>
            {/* <div className="col-md-4 mt-3">
              <label className="form-label">
                {t("GBC Type")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="gbc_type"
                value={gbcType}
                className="common-input form-select"
                onChange={handleGCBChange}
                required
              >
                <option value="">{t("Select GBC Type")}</option>
                {gcb.map((item) => (
                  <option value={item.id}>{t(item.type)}</option>
                ))}
              </select>
            </div> */}
            
            {/* <div className="col-md-4 mt-3">
              <label className="form-label">{t("UDISE")}</label>
              <input
                type="number"
                name="UDISE"
                className="form-control"
                value={UDISE}
                onChange={handleUDISE}
              />
            </div> */}
            <div className="col-md-4 ">
              <label className="form-label">
                {t("GBC Type")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="gbc_type"
                value={gbcType}
                className="common-input form-select"
                onChange={handleGCBChange}
                required
              >
                <option value="">{t("Select GBC Type")}</option>
                {gcb.map((item) => (
                  <option value={item.id}>{t(item.type)}</option>
                ))}
              </select>
            </div>
            <div
              className="col-md-4 mt-3"
              // style={{
              //   display: schoolType == "Residential" ? "block" : "none",
              // }}
            >
              <label className="form-label">
                {t("Hostel Type")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="hostelType"
                value={hostelType}
                className="common-input form-select"
                onChange={handleHostelType}
                required
              >
                <option value="">{t("Select Hostel Type")}</option>
                <option value="100 STBH">{t("100 STBH")}</option>
                <option value="100 STGH">{t("100 STGH")}</option>
                <option value="Anwesha">{t("Anwesha")}</option>
              </select>
            </div>
            <div
              className="col-md-4 mt-3"
              // style={{
              //   display: schoolType == "Residential" ? "block" : "none",
              // }}
            >
              <label className="form-label">
                {t("Year Of Construction")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="yearOfConstruction"
                value={yearOfConstruction}
                className="common-input form-select"
                onChange={handleYearsOfConstruction}
                required
              >
                <option value="">{t("Select YOE")}</option>
                {allYearOfConstruction.map((item) => (
                  <option value={item.year_of_const}>
                    {t(item.year_of_const)}
                  </option>
                ))}
              </select>
            </div>
           
          </div>
          <div className="row mt-5">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary me-2">
                {t("Submit")}
              </button>
              <button
                onClick={toggleClearButton}
                type="button"
                className="btn btn-secondary"
              >
                {t("Clear")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default HostelLogin;
